import type * as THREE from 'three'

/**
 * 递归将子树上所有 Object3D 的 layers 重置为仅包含指定层。
 *
 * @param root - 遍历起点对象
 * @param layer - 目标层编号，取值 0-31
 */
export function setLayerRecursive(root: THREE.Object3D, layer: number): void {
  root.traverse((object) => {
    object.layers.set(layer)
  })
}

/**
 * 递归将子树上所有 Object3D 的 layers.mask 设为给定位掩码。
 *
 * @param root - 遍历起点对象
 * @param mask - 32 位层位掩码
 */
export function setMaskRecursive(root: THREE.Object3D, mask: number): void {
  root.traverse((object) => {
    object.layers.mask = mask
  })
}

/**
 * 递归在子树上所有 Object3D 的 layers 中启用指定层，保留已有层。
 *
 * @param root - 遍历起点对象
 * @param layer - 待启用的层编号，取值 0-31
 */
export function enableLayerRecursive(root: THREE.Object3D, layer: number): void {
  root.traverse((object) => {
    object.layers.enable(layer)
  })
}
